/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Account_BodyInputs */

const en_platform_step_account_body = /** @type {(inputs: Platform_Step_Account_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free, no card and nothing to install.`)
};

const pl_platform_step_account_body = /** @type {(inputs: Platform_Step_Account_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatnie, bez karty i bez instalowania czegokolwiek.`)
};

/**
* | output |
* | --- |
* | "Free, no card and nothing to install." |
*
* @param {Platform_Step_Account_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_account_body = /** @type {((inputs?: Platform_Step_Account_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Account_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_account_body(inputs)
	return en_platform_step_account_body(inputs)
});